import React, { Fragment } from "react";

const Footer = () => {
  return (
    <Fragment>
      <footer>
        <div className="footer">
          <a href="www.christian-escobar.firebaseapp.com">
            <img src={process.env.PUBLIC_URL + "/logoCH.png"} alt="logo" />
          </a>
        </div>
      </footer>
    </Fragment>
  );
};
export default Footer;
